import { SbBlokData, storyblokEditable } from '@storyblok/react/rsc'
import { FC } from 'react'

import { PhnxSearchfindcomponent } from './Searchfindcomponent'

interface SearchfindcomponentBlokProps {
  blok: {
    searchType: 'both' | 'office' | 'adviser'
    showRadius?: boolean
  } & SbBlokData
}

const Searchfindcomponent: FC<SearchfindcomponentBlokProps> = ({ blok }) => {
  return (
    <div {...storyblokEditable(blok)}>
      <PhnxSearchfindcomponent blok={blok} />
    </div>
  )
}

export default Searchfindcomponent
